import { observer } from "mobx-react";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "../../../containers/settings/settingsEditCommon.css";
import { IOrgConfig } from "../../../models/currentUser/OrgConfig";
import { withPermissionFallback } from "../../HOC/withPermissionFallback/withPermissionFallback";
import { SubtitleDescription } from "../subtitleDescription";
import { AutoAssignedLimitInput } from "./autoAssignedLimitInput";
import { SnoozeAndCloseForm } from "./components/snoozeAndCloseForm/snoozeAndCloseForm";
import { AppPermission } from "@closerplatform/spinner-openapi";

export interface Props {
  orgConfig: IOrgConfig;
}

export const AssignmentRulesSettings = withPermissionFallback(
  AppPermission.SettingsGeneral,
  observer(({ orgConfig }: Props) => {
    return (
      <>
        <div className={styles.title}>
          <L10n id={"settings.assignmentRules.chatAssignmentLimit"} />
        </div>
        <div className={styles.section}>
          <SubtitleDescription
            subtitle={intl.formatMessage("settings.assignmentRules.chatAssignmentLimitPerAgent")}
            description={intl.formatMessage(
              "settings.assignmentRules.chatAssignmentLimitPerAgent.description"
            )}
          />
          <div className={styles.content}>
            <AutoAssignedLimitInput orgConfigOrProfile={orgConfig} />
          </div>
        </div>
        <SnoozeAndCloseForm orgConfig={orgConfig} />
      </>
    );
  })
);
